/** Ride-selection helpers lifted from the DGR register page module scope. */

/** Map legacy country URL slugs to ISO-ish codes (e.g. /register?country=australia) */
const countrySlugToCode: Record<string, string> = {
  australia: 'AU',
  canada: 'CA',
  germany: 'DE',
  spain: 'ES',
  france: 'FR',
  england: 'XE',
  scotland: 'XS',
  wales: 'XW',
  'northern-ireland': 'XI',
  'united-kingdom': 'GB',
  uk: 'GB',
  italy: 'IT',
  japan: 'JP',
  netherlands: 'NL',
  'new-zealand': 'NZ',
  'united-states': 'US',
  usa: 'US',
};

export function getInitialCountryFromParams(searchParams: {
  get: (key: string) => string | null;
}): string {
  const countryParam = searchParams.get('country');
  if (!countryParam) return '';
  return countrySlugToCode[countryParam.toLowerCase()] || countryParam.toUpperCase();
}

export function parseRideMinimumDonation(minimumDonation: string | null | undefined): number {
  if (!minimumDonation) return 0;
  const parsed = Number(minimumDonation);
  return Number.isFinite(parsed) && parsed > 0 ? parsed : 0;
}

export function getCapacityBadgeValue(capacity: string | null | undefined): string | null {
  if (!capacity) return null;
  const trimmed = capacity.trim();
  if (!trimmed || trimmed === '0') return null;
  return trimmed;
}

export function parseRideCapacity(capacity: string | null | undefined): number | null {
  if (!capacity) return null;
  const parsed = Number(capacity);
  return Number.isFinite(parsed) && parsed > 0 ? parsed : null;
}

/** Ride row shape returned by publicLookups.ridesByLocation */
export interface RideData {
  id: string;
  name: string;
  slug: string;
  capacity: string | null;
  minimumDonation: string | null;
  currentRegistrations: number;
  isPostponed?: boolean;
  isCancelled?: boolean;
  postponedDate?: string | null;
}

export function isRideFull(ride: RideData | undefined): boolean {
  if (!ride) return false;
  const capacity = parseRideCapacity(ride.capacity);
  return capacity !== null && ride.currentRegistrations >= capacity;
}
